import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAuthContext } from "../../hooks/useAuthContext";
import axios from "axios";
import { ApiConnectionString } from "../../constants/ApiConntection";
import LoadingSpinner from "../../components/LoadingSpinner";
import { CheckCircle } from "react-bootstrap-icons";

export default function Success() {
  const { checkoutSessionId, ownerId } = useParams();
  const { user } = useAuthContext();
  const [isLoading,setIsLoading] = useState(true)
  const [checkoutSession, setCheckoutSession] = useState(null);
  const navi = useNavigate()
  const fetchData = async () => {
    setIsLoading(true);
    try {
      const checkoutSessionResponse = await axios.get(
        `${ApiConnectionString}/api/checkoutsession/${checkoutSessionId}/${ownerId}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
      if (checkoutSessionResponse.status === 200) {
        setCheckoutSession(checkoutSessionResponse.data);
      }
    } catch (error) {
      console.error("Error fetching checkout session:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
if(user){
fetchData();
}
  },[user])

  if(isLoading){
    return(
        <div>
            <LoadingSpinner />
        </div>
    )
  }else if(checkoutSession){ 
      return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-6">
          <div className="bg-white shadow-lg rounded-2xl p-6 text-center max-w-md w-full">
            <h2 className=" font-bold text-success">Payment Successful!</h2>
            <CheckCircle size={25}  className="text-success" />
            <p className="text-muted">Thank you for your subscription.</p>
            <div className="mt-4 p-4 border rounded-lg bg-gray-50">
         
              <p className="text-lg">
                <span className="font-semibold">Mode:</span> {checkoutSession.mode}
              </p>
              <p className="text-lg">
                <span className="font-semibold">Amount Paid:</span>{" "}
                £{(checkoutSession.amountTotal / 100).toFixed(2)}
              </p>
            </div>
            <p>A detailed email receipt will be delivered to you. If it does not appear, please check your junk/spam folders.</p>
            <p>Please allow a few moments for the system to update before you can book into classes with your purchase.</p>

            <button
               onClick={() => navi(`/club/${checkoutSession.clubId}`)}
              className="saveChanges-button my-3"
            >
              Return to club page
            </button>

            <p>You can also keep track of your subscriptions and class passes with the button below.</p>
            <button
               onClick={() => navi(`/MySubscriptionsAndTokens`)}
              className="saveChanges-button my-3"
            >
              My Subscriptions and Class Passes
            </button>

          </div>
        </div>
      );
  }
  

}
